import React, { useState, useEffect } from 'react';
import styles from './NotProtectedAlert.module.css';
import UserStore from '../../store/user-store';

const translations = {
  en: {
    title: "🔒 Connection is secure",
    message: "Your connection is protected. Your data is safe and encrypted.",
    ok: "OK",
    ipAddress: "IP Address",
    location: "Location",
    isp: "ISP"
  },
  ru: {
    title: "🔒 Соединение защищено",
    message: "Ваше соединение защищено. Ваши данные в безопасности и зашифрованы.",
    ok: "OK",
    ipAddress: "IP адрес",
    location: "Локация",
    isp: "Провайдер"
  }
};

const EyeIcon = ({ closed }) => (
  <svg 
    className={`${styles.eye_icon} ${closed ? styles.closed : ''}`}
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="1.5"
  >
    {closed ? (
      <>
        <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-10-7-10-7a18.45 18.45 0 015.06-5.94" />
        <path d="M14.12 14.12a3 3 0 11-4.24-4.24" />
        <path d="M9.88 9.88a3 3 0 114.24 4.24" />
        <path d="M9.9 4.24A10.07 10.07 0 0112 4c7 0 10 7 10 7a18.45 18.45 0 01-2.16 3.19" />
        <line x1="2" y1="2" x2="22" y2="22" />
      </>
    ) : (
      <>
        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" />
        <circle cx="12" cy="12" r="3" />
      </>
    )}
  </svg>
);

const ProtectedAlert = ({ onClose, ipData }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [revealed, setRevealed] = useState({
    ip: false,
    location: false,
    isp: false
  });
  
  const lang = translations[UserStore.langCode] || translations.en;

  useEffect(() => {
    // Trigger animation after mount
    requestAnimationFrame(() => {
      setIsVisible(true);
    });
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      setIsOpen(false);
      onClose?.();
    }, 300);
  };

  if (!isOpen) return null;

  return (
    <div className={`${styles.modal_overlay} ${isVisible ? styles.visible : ''}`}>
      <div className={styles.modal_content}>
        <button 
          className={styles.close_button} 
          onClick={handleClose}
        >
          ×
        </button>

        <div className={`${styles.warning_header} ${styles.protected_header}`}>
          {lang.title}
        </div>

        <div className={styles.warning_content}>
          {lang.message}
        </div>

        {ipData && (
          <div className={styles.ip_info}>
            <p>
              <strong>{lang.ipAddress}</strong>
              <span 
                className={revealed.ip ? styles.revealed : ''}
                onClick={() => setRevealed(prev => ({ ...prev, ip: !prev.ip }))}
              >
                <div className={styles.text}>{ipData.query}</div>
                <EyeIcon closed={!revealed.ip} />
              </span>
            </p>
            <p>
              <strong>{lang.location}</strong>
              <span 
                className={revealed.location ? styles.revealed : ''}
                onClick={() => setRevealed(prev => ({ ...prev, location: !prev.location }))}
              >
                <div className={styles.text}>{ipData.city}, {ipData.regionName}</div>
                <EyeIcon closed={!revealed.location} />
              </span>
            </p>
            <p>
              <strong>{lang.isp}</strong>
              <span 
                className={revealed.isp ? styles.revealed : ''}
                onClick={() => setRevealed(prev => ({ ...prev, isp: !prev.isp }))}
              >
                <div className={styles.text}>DeGuard.io</div>
                <EyeIcon closed={!revealed.isp} />
              </span>
            </p>
          </div>
        )}

        <div className={styles.button_group}>
          <button 
            className={`${styles.button} ${styles.primary}`}
            onClick={handleClose}
          >
            {lang.ok}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProtectedAlert; 